import React, { useEffect, useRef } from "react";

/**
 * Adds `in` class when element enters viewport so `.reveal` styles animate.
 * No external animation lib for this — keeps bundle small.
 */
export function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    const nodes = el.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    nodes.forEach((n) => io.observe(n));
    return () => io.disconnect();
  }, []);
  return ref;
}

/** Whole-page reveal observer */
export default function RevealRoot({ children }) {
  const ref = useReveal();
  return <div ref={ref}>{children}</div>;
}
